import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import { useAgents } from '../../hooks/useAgents';

function ChatMessages({ messages, streamingContent, sending, progressStatus, pendingBatches = [], onSchedulePost }) {
  const { getAgent } = useAgents();
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, streamingContent]);

  if (messages.length === 0 && !sending) {
    return (
      <div className="chat-messages">
        <div className="chat-messages-empty">
          <div className="chat-messages-empty-icon">&#x1F4AC;</div>
          <div className="chat-messages-empty-text">
            Selecione um agente e envie uma mensagem para comecar a conversa.
          </div>
        </div>
      </div>
    );
  }

  const isBatchPending = (msg) =>
    msg.metadata?.batch_status === 'processing' && !msg.content;

  return (
    <div className="chat-messages">
      {messages.map((msg) => {
        const isUser = msg.role === 'user';
        const agent = !isUser ? getAgent(msg.agent_id) : null;

        // Mensagem batch pendente
        if (!isUser && isBatchPending(msg)) {
          return (
            <div key={msg.id} className="chat-message chat-message--assistant">
              <div className="chat-message-avatar">
                {agent?.icon || '\u23F3'}
              </div>
              <div className="chat-message-body">
                {agent && (
                  <span className="chat-message-agent-name">{agent.name}</span>
                )}
                <div className="chat-message-batch-pending">
                  <div className="chat-progress-spinner" />
                  Processando em batch (50% mais barato) — voce sera notificado quando estiver pronto.
                </div>
              </div>
            </div>
          );
        }

        return (
          <div key={msg.id} className={`chat-message chat-message--${msg.role}`}>
            <div className="chat-message-avatar">
              {isUser ? '\uD83D\uDC64' : (agent?.icon || '\uD83E\uDD16')}
            </div>
            <div className="chat-message-body">
              {!isUser && agent && (
                <span className="chat-message-agent-name">{agent.name}</span>
              )}
              <div className="chat-message-bubble">
                <ReactMarkdown>{msg.content}</ReactMarkdown>
              </div>
              {!isUser && msg.content && onSchedulePost && (
                <button
                  className="chat-schedule-btn"
                  onClick={() => onSchedulePost(msg)}
                  title="Aprovar conteudo e enviar para aprovacao do cliente"
                >
                  &#x1F4C5; Aprovar e Enviar p/ Cliente
                </button>
              )}
            </div>
          </div>
        );
      })}

      {sending && progressStatus && (
        <div className="chat-progress">
          <div className="chat-progress-spinner" />
          {progressStatus}
        </div>
      )}

      {sending && streamingContent && (
        <div className="chat-message chat-message--assistant">
          <div className="chat-message-avatar">{'\uD83E\uDD16'}</div>
          <div className="chat-message-body">
            <div className="chat-message-bubble">
              <ReactMarkdown>{streamingContent}</ReactMarkdown>
            </div>
          </div>
        </div>
      )}

      {sending && !streamingContent && !progressStatus && (
        <div className="chat-typing">
          <div className="chat-typing-dots">
            <div className="chat-typing-dot" />
            <div className="chat-typing-dot" />
            <div className="chat-typing-dot" />
          </div>
          Pensando...
        </div>
      )}

      <div ref={bottomRef} />
    </div>
  );
}

export default ChatMessages;
